import { Component, Children, createRef, cloneElement } from 'react';

const addPropsToChild = (node, props) => cloneElement(node, { ...props });

class TextLoadingWrapper extends Component {
  state = {
    children: Children.map(this.props.children, child => {
      const ref = createRef();
      const className = cx(child.props.className, this.props.animationClass);

      return addPropsToChild(child, { ref, className });
    }),
  };

  componentDidMount() {
    this.setTextLoadingAnimation();
  }

  setTextLoadingAnimation() {
    const children = Children.map(this.state.children, child => {
      if (child.ref.current === null) {
        return child;
      }

      const { color, lineHeight } = getComputedStyle(child.ref.current);

      const childStyle = {
        backgroundColor: '#eee',
        minHeight: lineHeight,
      };

      return addPropsToChild(child, {
        style: childStyle,
      });
    });

    this.setState({ children });
  }

  render() {
    const { children, condition } = this.props;
    return !condition ? this.state.children : children;
  }
}

export default TextLoadingWrapper;
